import {memo} from "react";
import s from "./RadioGroup.module.css";

// interface RadioItem {
//   value: string | number;
//   title: string;
// }

export const RadioGroup = memo(({nameGroup, items, activeValue, onChange}) => {
  return (
    items?.map((item, index) => (
      <label className={s.item} key={index}>
        <input
          className={s['radio-input']}
          type={"radio"}
          name={nameGroup}
          value={item?.value || ""}
          checked={activeValue === item?.value}
          onChange={() => onChange(item?.value)}
        />
        <span className={s.customRadio}/>
        <p className={s.name}>{item?.title}</p>
      </label>
    ))
  )
});